import { Link } from 'react-router-dom';
import { articles, featuredArticles } from '@/mocks/gallery';

export default function FeaturedGallery() {
  const featured = articles.filter((a) => featuredArticles.includes(a.id));

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900 mb-3">
            精选合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑精选的高质量美女写真作品，每一组都是用心之选
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featured.map((article) => {
            const category = article.category;
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-white rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 text-xs font-medium bg-primary-500 text-white rounded-full">
                      {category === 'qingchun' ? '清纯系' :
                       category === 'qizhi' ? '气质系' :
                       category === 'shishang' ? '时尚系' :
                       category === 'xinggan' ? '性感系' :
                       category === 'gufeng' ? '古风系' : '日系'}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-bold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <div className="flex items-center gap-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views > 9999 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-heart-line"></i>
                        {article.likes}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/qingchun"
            className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-100 text-secondary-800 font-medium rounded-full hover:bg-secondary-200 transition-colors text-sm whitespace-nowrap"
          >
            查看更多作品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}